let resolved = false;

let authReadyResolve;
const waitForAuthReady = new Promise((resolve) => {
  authReadyResolve = () => {
    if (!resolved) {
      resolved = true;
      resolve();
    }
  };
}); 

/**
 * Resolves the auth-ready promise exactly once.
 * Call this after Firebase auth state is known.
 */
function resolveAuthReady() {
  authReadyResolve();
}

export { waitForAuthReady, resolveAuthReady };